import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["columns", "rowActionProps", "getActionsForRow"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Helpers
import { makeActionsCellConfig, getColumnsWithActions } from './withInputTableActions.helpers';
var ACTION_COLUMN_WIDTH = 52;
var withTableActions = function withTableActions(WrappedComponent) {
  var WithTableActions = /*#__PURE__*/function (_Component) {
    _inherits(WithTableActions, _Component);
    var _super = _createSuper(WithTableActions);
    function WithTableActions(props) {
      var _this;
      _classCallCheck(this, WithTableActions);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getColumnsWithActions", defaultMemoize(getColumnsWithActions));
      _defineProperty(_assertThisInitialized(_this), "setActionCellConfig", function () {
        var _this$props = _this.props,
          rowActionProps = _this$props.rowActionProps,
          getActionsForRow = _this$props.getActionsForRow,
          getActionCellProps = _this$props.getActionCellProps;
        var _rowActionProps$title = rowActionProps.title,
          title = _rowActionProps$title === void 0 ? '' : _rowActionProps$title,
          _rowActionProps$width = rowActionProps.width,
          width = _rowActionProps$width === void 0 ? ACTION_COLUMN_WIDTH : _rowActionProps$width,
          _rowActionProps$class = rowActionProps.className,
          className = _rowActionProps$class === void 0 ? '' : _rowActionProps$class,
          _rowActionProps$heade = rowActionProps.headerClassName,
          headerClassName = _rowActionProps$heade === void 0 ? '' : _rowActionProps$heade,
          visibleActionCount = rowActionProps.visibleActionCount;
        _this.actionCellConfig = makeActionsCellConfig({
          title: title,
          width: width,
          className: className,
          headerClassName: headerClassName,
          getActionsForRow: getActionsForRow,
          visibleActionCount: visibleActionCount,
          getActionCellProps: getActionCellProps
        });
      });
      _this.setActionCellConfig();
      return _this;
    }
    _createClass(WithTableActions, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          columns = _this$props2.columns,
          rowActionProps = _this$props2.rowActionProps,
          getActionsForRow = _this$props2.getActionsForRow,
          restProps = _objectWithoutProperties(_this$props2, _excluded);
        var columnsWithAction = this.getColumnsWithActions(columns, this.actionCellConfig);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          columns: columnsWithAction
        }));
      }
    }]);
    return WithTableActions;
  }(Component);
  WithTableActions.propTypes = {
    rowActionProps: PropTypes.object,
    getActionsForRow: PropTypes.func,
    columns: PropTypes.array,
    getActionCellProps: PropTypes.func
  };
  WithTableActions.defaultProps = {
    rowActionProps: EMPTY_OBJECT,
    getActionsForRow: _noop,
    columns: EMPTY_ARRAY,
    getActionCellProps: _noop
  };
  return WithTableActions;
};
export default withTableActions;